import { Component, OnInit } from '@angular/core';

import { OrganizationService } from '../organization.service';
import { Organization } from '../organization.model';

@Component({
  selector: 'app-organization-list',
  templateUrl: './organization-list.component.html',
  styleUrls: ['./organization-list.component.scss']
})
export class OrganizationListComponent implements OnInit {

  public subOrgs: Organization[] = [];

  constructor(
    public organizationService: OrganizationService
  ) { }

  ngOnInit(): void {
    this.subOrgs = this.organizationService.subOrgs;
    this.organizationService.subOrgsSubject.subscribe((subOrgs) => {
      this.subOrgs = subOrgs;
    });
  }

}
